<template>
  <div>
    <div class="SubnetResource-title">
      <div>{{ $t("RAM.AWS.Subnet.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:subnetResource:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:subnetResource:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="SubnetResource-top">
      <subnet-resource-search
        ref="subnetResourceSearchChild"
      ></subnet-resource-search>
    </div>
    <table-subnet-resource></table-subnet-resource>
  </div>
</template>

<script>
import SubnetResourceSearch from "../subnet/SubnetResourceSearch";
import TableSubnetResource from "../subnet/TableSubnetResource";

export default {
  name: "SubnetResource",
  components: {
    SubnetResourceSearch,
    TableSubnetResource
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      accountNameSearchID: "",
      companyId: "",
      subnetSearchKey: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.subnetResourceSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 11
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.accountNameSearchID = this.$refs.subnetResourceSearchChild.accountNameSearchKey;
      this.subnetSearchKey = this.$refs.subnetResourceSearchChild.subnetSearchKey;
      this.companyId = this.$refs.subnetResourceSearchChild.companyId;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSSubnet({
          accountName: this.accountNameSearchID,
          companyId: this.companyId,
          subnetId: this.subnetSearchKey
        })
        .then(res => {
          let fileName = this.$t('RAM.export.subnet');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.SubnetResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.SubnetResource-title > div:nth-child(1) {
  float: left;
}
.SubnetResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.SubnetResource-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/subnet/SubnetResource.vue